import type { Components } from '@mui/material/styles';

export default function MuiContainer(): Components['MuiContainer'] {
  return {};
}
